<template lang="pug">
	div(style="font-size:15px;" title="Run Report")
		details(ref="reportMenu" @toggle="m_menuToggle")
			<summary style="color:white;background-color:#007bff;">
				span(style="text-align:center;")
					strong  My Reports
			</summary>
			<hr style="margin:0em;border-bottom:0.01em solid #adb5bd;"/>
			div
				<b-table small 	:fields="d_reportColumns" :items="c_allReports" sticky-header="100px" thead-tr-class="d-none" selected-variant="success" show-empty empty-text="No Reports" selectable select-mode="single" @row-selected="m_onRowSelected">
					<template v-slot:cell(run)="data">
						div()
							span.report-running(v-if="p_reportRunning && d_runReportId==data.index")
								b-spinner(small variant="primary" title="Report is being generated" label="Running" class="report-spin")
							fa-layers(v-else)
								fa-icon(icon="file-pdf" style="color: red;" class="btn-run" v-if="d_selectedRowId==data.index" @click.stop="m_runReport(data.index)")
								fa-icon(:icon="['fas', 'check']" transform="up-2 right-2" v-if="d_selectedRowId==data.index&&data.index==d_runReportId")
					</template>
				</b-table>
</template>
<script>
import {fn_getModal_confirm,kbdpAlert} from "@/utils/util.js";
import {refData} from "@/utils/ref-data.js";
import {fn_simpleSearch,settings as api} from "@/utils/api.js";
export default {
	name: "kt-report-list",
	components: {},
	created() {},
	BeforeUnmount(){},
	mounted() {},
	data() {
		return {
				d_allReports:null,
				d_reportColumns:[{label: "Reports",key: "title",thStyle:"border-right: 0.1em solid #adb5bd;"},
								"Run"],
				d_selectedRow:null,
				d_selectedRowId:null,
				d_runReportId:null,
		};
	},
	props: {
		p_reportContext:String,
		p_allReports:Array,
		p_reportRunning:{type:Boolean, default:false},
	},
	computed: {
			c_rowSelected(){return this.d_rowSelected;},
			c_allReports(){ return this.p_allReports;},
	},
	methods: {
		m_keepMenuOpen(){
					var menu=this.$refs.reportMenu;
					if(menu) menu.open=true;
					},
		m_menuToggle(event){
					if(this.p_reportRunning && event.target && !event.target.open) this.m_keepMenuOpen();
					},
		m_runReport(idx){
					if(this.p_reportRunning) return;
					this.d_runReportId=idx;
					this.m_keepMenuOpen();
					this.$emit('reportSelected',this.d_selectedRow);
					},
		m_onRowSelected(row){
					if(row.length>0){
						this.d_selectedRow=row[0];
						this.d_selectedRowId=this.p_allReports.findIndex(r=>r.title==row[0].title);
						if(!this.p_reportRunning) this.d_runReportId=null;
						
					} else if(!this.p_reportRunning) {this.d_selectedRow=null;
							this.d_selectedRowId=null;
							this.d_runReportId=null;
							}
							
		}
	},
	watch: {
		p_reportRunning(running){
			if(running) this.m_keepMenuOpen();
		}
	}
};
</script>
<style lang="less">
hr{width:100%;}
.grid-container {
  display: grid;
  grid-template-columns: auto auto;
}
.grid-item {
  border: none; 
  font-size: 15px;
  text-align: left;
}
fieldset {
-webkit-border-radius: 8px;
-moz-border-radius: 8px;
border-radius: 8px;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒"; 
  background-color:white;
  /* you can style it however you want, use background-image for example */
}

/* By using [open] we can define different styles when the disclosure widget is open */
details[open] summary::before { 
  content:"🠣";  /*"🡑"*/ 
  background-color:white;  
}
.primary{color:#007bff;}
.btn-run{
		margin-left:0.1em;
		width:0.8em;
		height:0.8em;
		}
.report-spin{
		margin-left:0.4em;
		width:0.8em;
		height:0.8em;
		vertical-align:middle;
		}
.report-running{
		margin-left:0.35em;
		font-size:0.85em;
		font-weight:600;
		}
</style>